$(document).ready(function () {
  if($('.event').length > 0) {
    const carouselEvent = document.querySelector('.event__list');
    if (carouselEvent) {
      new Glider(carouselEvent, {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        dots: '#dots-event',
        arrows: {
          prev: '#glider-prev-event',
          next: '#glider-next-event'
        },
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      })
    }
    if(($(this).find('#dots-event').children().length < 2 )) {
      $(this).find("#dots-event").hide();
      $(this).find(".glider-prev").hide();
      $(this).find(".glider-next").hide();
    }
  }
});